<label class="switch">
    <input type="checkbox" (click)="toggleEvent()" [checked]="checked">
    <span class="slider round"></span>
</label>